import {ModuleTree} from "vuex";
import {RootState} from "@/store/types";
import tags from "./tags";
import roles from "./roles";

export const modules: ModuleTree<RootState> = {
  tags,
  roles,
};
